<main>
    <!-- main section -->
    <section class="banner-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="identity">
                        <h1 class="heading">A Brighter Tomorrow</h1>
                        <p class="text">Unveiling the new BajajCapital Brand Identity: A Promise of Trust, Growth &
                            Safety </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="brand-wall">
    </section>
    <section class="transformation">
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <h2 class="heading">Modernizing wealth: <span class="d-block">The rebranding journey</span></h2>
                    <p class="text">BajajCapital, the Indian financial stalwart with over half a century of
                        dedication, introduces a new logo that symbolizes our unwavering commitment to trust,
                        growth, and safety: the core fundamentals of partnership. Our previous logo stood strong for
                        decades, representing our identity, but the evolution of our brand demanded a refreshed
                        emblem that mirrors our modern vision yet pays homage to our enduring values.</p>
                    <h2 class="heading second">Why the Transformation?</h2>
                    <p class="text">The digital age calls for <strong>sophistication and simplicity</strong>. Our
                        new logo, backed by 60+ years of assurance, is a harmonious blend of modernity and legacy,
                        of growth and trust. The colors and geometric elements, carefully chosen, articulate our
                        organizational values, while the iconic design reflects our dedication to being the pillar
                        of financial security. We felt the need to:</p>
                    <ul class="data-list mt-5">
                        <li>Establish a distinctive brand identity</li>
                        <li>Create an adaptable and contemporary emblem</li>
                        <li>Evolve beyond the confines of our previous logo, which, while iconic, had begun to feel
                            out of sync with the usage.</li>
                    </ul>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <div class="right_logo">
                        <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/logo.png"
                            class="img-fluid" alt="right_logo">
                    </div>
                    <div class="right_logo logoicon">
                        <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/logo_icon.png"
                            class="img-fluid" alt="right_logo">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="visualizing">
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <div class="visuals">
                        <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/visual-a.png"
                            class="img-fluid" alt="visual">
                        <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/visual-b.png"
                            class="img-fluid" alt="visual">
                        <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/visual-c.png"
                            class="img-fluid" alt="visual">
                        <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/visual-d.png"
                            class="img-fluid" alt="visual">
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <div class="content">
                        <h3 class="heading">Visualizing Partnership</h3>
                        <p class="text">When two people or organisations work together,
                            they can achieve more than they could ever do on their own. But not all partnerships
                            are created equal. Our role in the lives of our partners is
                            <strong>TO BE SEEN AS BUILDERS OF PARTNERSHIPS</strong>. We balance each other's
                            weaknesses.
                            We help remove doubt & uncertainty and help them grow personally, professionally,
                            emotionally and financially. To build a strong and lasting partnership, you need to
                            focus
                            on these 6 pillars:
                        </p>
                        <ol class="list">
                            <li><strong>Shared Responsibility: </strong>Both parties in a partnership need to be
                                committed to its
                                success. This means being transparent with your commitments, making
                                decisions together, and performing your duties effectively.</li>
                            <li><strong>Balance: </strong>A strong partnership is one where each party balances the
                                other's
                                weaknesses. This means bringing your own strengths to the table and working
                                together to help each other grow.</li>
                            <li><strong>Forward-Thinking: </strong>A partnership should be constantly evolving and
                                improving.
                                You should always be looking for ways to improve your communication,
                                collaboration, and problem-solving skills.</li>
                            <li><strong>Equitable distribution of Time: </strong>A partnership is a two-way street.
                                Both
                                parties
                                need to be willing to put in the time and effort to make it work.</li>
                            <li><strong>Financial Expertise: </strong>If you're looking for a partner to help you
                                achieve your
                                financial goals, you need to make sure they have the expertise and experience to
                                do so.</li>
                            <li><strong>Total Well-Being: </strong>A partnership should be about more than just
                                money.
                                It should
                                be about helping each other achieve total well-being, both physically and
                                emotionally.</li>
                        </ol>
                        <p class="text">If you can focus on these 6 pillars, you'll be well on your way to building
                            a
                            strong and
                            lasting partnership that will help you achieve your goals.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="embark">
        <div class="container">
            <p class="text">Embark on a Journey of Timeless Partnership with BajajCapital that builds Wealth for
                you and your Generations.</p>
        </div>
    </section>
    <section class="new_begin">
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <div class="left">
                        <div class="content">
                            <h3 class="heading">Welcome to new beginnings</h3>
                            <p class="text">Our first logo resonated with BajajCapital's ethos of trust, as it
                                portrayed a steady guide for customers' financial aspirations.</p>
                            <p class="text">Our transitional logo reflected BajajCapital's balance between tradition
                                and progress, mirroring a reliable partner while embracing changing financial
                                landscapes.
                            </p>
                            <p class="text">Our new-age logo symbolizes BajajCapital's ethos of partnership, forging
                                a narrative where shared financial aspirations are nurtured through innovative
                                collaboration.</p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/beginning.png"
                        class="img-fluid" alt="beginning">
                </div>
            </div>
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <div class="left">
                        <div class="content">
                            <h3 class="heading">A journey of transformation: Where partnership meets prosperity</h3>
                            <p class="text">At the intersection of change and constancy is BajajCapital's new
                                identity. A transformative step that holds true to the principles that have shaped
                                our legacy. As we evolve visually, our promise stands resolute – to be the partner
                                you trust, the ally you lean on, and the guide leading you towards financial
                                triumph.</p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/transformation.png"
                        class="img-fluid w-100" alt="transformation">
                </div>
            </div>
        </div>
    </section>
    <section class="legacy">
        <div class="container">
            <div class="col-xl-7 col-lg-7 col-md-12 pl-0">
                <h4 class="main_heading">When a legacy evolves, a legacy grows </h4>
            </div>
            <div class="row content">
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <h5 class="heading">Shri Ganesha: Our eternal partner & a timeless bond</h5>
                    <p class="text">Our relationship with the divine Lord Ganesha is immortal and deeply revered. As
                        He showers us with blessings of abundance and success, we, at BajajCapital, reflect those
                        very ideals in our ethos. Our logo is a testament to this unwavering bond – a constant
                        companion on your financial voyage.</p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/e1.png"
                        class="img-fluid" alt="mockup">

                </div>

                <div class="col-xl-6 col-lg-6 col-md-12">
                    <h5 class="heading">The Growth Graph: Nurturing growth through the power of partnership</h5>
                    <p class="text">Imagine your ambitions visualised as an upward-moving graph, and standing beside
                        it is BajajCapital, ensuring every milestone is achieved, every dream realised.</p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/e2.png"
                        class="img-fluid" alt="mockup">
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <h5 class="heading">Guiding light of the world: the Sun, the radiant Surya-tilak</h5>
                    <p class="text">As the sun brings a new dawn, its radiant beams signifying hope, the Surya Tilak
                        in our logo represents our role in your financial journey – leading the way, ensuring
                        clarity, and driving prosperity.</p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/e3.png"
                        class="img-fluid" alt="mockup">
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <h5 class="heading">The mighty Rupee: Building partnerships with value</h5>
                    <p class="text">Trust is built over transactions and promises kept. Just as every rupee is
                        invaluable, our dedication stands firm, underscoring our enduring partnership.</p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/e4.png"
                        class="img-fluid" alt="mockup">
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <h5 class="heading">Number 9: The symbol of optimal growth</h5>
                    <p class="text">The essence of the number 9 is woven intricately into our new brand identity,
                        symbolising the zenith of growth and partnership, ensuring a future filled with success
                        and boundless prospects.</p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/e5.png"
                        class="img-fluid" alt="mockup">
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <h5 class="heading">A future forged in partnership</h5>
                    <p class="text">Our reimagined logo is more than a visual transformation; it's a commitment. A
                        promise that BajajCapital's legacy of partnership, growth, and success will only strengthen
                        as we march forward.</p>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/e6.png"
                        class="img-fluid" alt="mockup">
                </div>
            </div>
            <div class="content desktop">
                <div class="owl-two owl-carousel owl-theme">
                    <div class="item">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <h5 class="heading">Shri Ganesha: Our eternal partner & a timeless bond</h5>
                                <p class="text">At the intersection of change and constancy is BajajCapital's new
                                    identity. A
                                    transformative step that holds true to the principles that have shaped our
                                    legacy. As we
                                    evolve visually, our promise stands resolute – to be the partner you trust, the
                                    ally you
                                    lean on, and the guide leading you towards financial triumph.</p>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/e1.png"
                                    class="img-fluid" alt="mockup">

                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <h5 class="heading">The Growth Graph: Nurturing growth through the power of
                                    partnership</h5>
                                <p class="text">Imagine your ambitions visualised as an upward-moving graph, and
                                    standing beside
                                    it is BajajCapital, ensuring every milestone is achieved, every dream realised.
                                </p>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/e2.png"
                                    class="img-fluid" alt="mockup">
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <h5 class="heading">Guiding light of the world: the Sun, the radiant Surya-tilak
                                </h5>
                                <p class="text">As the sun brings a new dawn, its radiant beams signifying hope, the
                                    Surya Tilak
                                    in our logo represents our role in your financial journey – leading the way,
                                    ensuring
                                    clarity, and driving prosperity.</p>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/e3.png"
                                    class="img-fluid" alt="mockup">
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <h5 class="heading">The mighty Rupee: Building partnerships with value</h5>
                                <p class="text">Trust is built over transactions and promises kept. Just as every
                                    rupee is
                                    invaluable, our dedication stands firm, underscoring our enduring partnership.
                                </p>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/e4.png"
                                    class="img-fluid" alt="mockup">
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <h5 class="heading">Number 9: The symbol of optimal growth</h5>
                                <p class="text">The essence of the number 9 is woven intricately into our new brand
                                    identity,
                                    symbolising the zenith of growth and partnership, ensuring a future filled with
                                    success
                                    and boundless prospects.</p>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/e5.png"
                                    class="img-fluid" alt="mockup">
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <h5 class="heading">A future forged in partnership</h5>
                                <p class="text">Our reimagined logo is more than a visual transformation; it's a
                                    commitment. A
                                    promise that BajajCapital's legacy of partnership, growth, and success will only
                                    strengthen
                                    as we march forward.</p>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-12">
                                <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/e6.png"
                                    class="img-fluid" alt="mockup">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="energy">
        <div class="container">
            <div class="row align-items-end">
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <div class="content">
                        <h4 class="heading">Fueling potential energy: Empowering aspirations</h4>
                        <p class="text">Every wealth creation journey starts from that first step, that first
                            invested money, that first coin. The coin is placed in the huge round sphere (earth) and
                            is placed at the centre. Like stored power waiting to be unleashed, your financial
                            potential is our
                            focus. BajajCapital fuels this potential, guiding your aspirations to fruition with
                            unwavering
                            support and comprehensive services.</p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/potential.png"
                        class="img-fluid" alt="potential">
                </div>
            </div>
            <div class="row align-items-end second">
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <div class="content">
                        <h4 class="heading">Harnessing kinetic energy: Propelling partnerships</h4>
                        <p class="text">Now imagine giving a slight nudge to the coin, like you invest this coin to
                            add to your wealth and when this happens, the coin possesses Kinetic energy. Just as
                            motion propels change, our partnership with you is a dynamic force. BajajCapital
                            harnesses kinetic energy to drive innovation and momentum, ensuring your financial
                            journey is ever-advancing.</p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/potential.png"
                        class="img-fluid" alt="potential">
                </div>
            </div>
        </div>
    </section>
    <section class="mockups">
        <div class="container">
            <div class="mockup">
                <div class="left">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/1.png"
                        class="img-fluid" alt="mockup">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/2.png"
                        class="img-fluid" alt="mockup">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/3.png"
                        class="img-fluid" alt="mockup">
                </div>
                <div class="right">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/4.png"
                        class="img-fluid" alt="mockup">
                    <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mockups/5.png"
                        class="img-fluid" alt="mockup">
                </div>
            </div>
        </div>
    </section>
    <section class="mockups-mobile desktop">
        <div class="container">
            <div class="owl-three owl-carousel owl-theme">
                <div class="item">
                    <div class="item_data">
                        <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mobile/1.png"
                            alt="mockup">
                    </div>
                </div>
                <div class="item">
                    <div class="item_data">
                        <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mobile/2.png"
                            alt="mockup">
                    </div>
                </div>
                <div class="item">
                    <div class="item_data">
                        <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mobile/3.png"
                            alt="mockup">
                    </div>
                </div>
                <div class="item">
                    <div class="item_data">
                        <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mobile/4.png"
                            alt="mockup">
                    </div>
                </div>
                <div class="item">
                    <div class="item_data">
                        <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/mobile/5.png"
                            alt="mockup">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="partnership">
        <div class="container">
            <div class="content">
                <h4 class="heading">Our legacy of partnership</h4>
                <p class="text">BajajCapital's journey is an ode to unwavering partnerships. With our foundation
                    laid on core values – integrity, trust, and empathy – we've been a beacon of financial guidance
                    since 1964. Beyond numbers, our brand symbolises shared aspirations, collective
                    growth, and unwavering support. As we unveil our revamped identity, remember that
                    our core remains unchanged. We're not just a financial institution; we are a partner in
                    your journey of financial aspirations. Our story is your story, and together, we craft a legacy
                    bound by trust and partnership. Welcome aboard.</p>
            </div>
        </div>
    </section>
    <button onclick="topFunction()" id="myBtn" title="Go to top" style="display: block;">
        <img src="https://iitpl-mf-designs.s3.ap-south-1.amazonaws.com/Mayur/landing-pages/brand-identity/images/bottom.png"
            alt="top">
    </button>
</main>